<template>
  <div class="add-student-page">
    <div>
      <div class="closeIcon" @click="closePopup">X</div>
      <div class="page-title">新增学员</div>
      <div class="form">
        <div class="item">
          <div class="label"><span class="tip">*</span>手机号</div>
          <div class="inputItem">
            <input placeholder="请输入手机号" type="number" v-model="phone" v-on:blur="inputBlur" />
          </div>
        </div>
        <div class="item" v-show="showVerifyCode">
          <div class="label"><span class="tip">*</span>验证码</div>
          <div class="inputItem">
            <input placeholder="请输入验证码" type="text" class="verify-input" v-model="code" v-on:blur="handleVerifyCodeBlur" />
            <span class="verify-btn">
              <span @click="handleSendCode()" class="getvericode" :disabled="countDownDisable">{{ codeTip }}</span>
            </span>
          </div>
        </div>
        <div class="item">
          <div class="label"><span class="tip">*</span>学员姓名</div>
          <div class="inputItem">
            <input placeholder="请输入学员姓名" type="text" v-model="studentName" v-on:blur="inputBlur" />
          </div>
        </div>
        <div @click="submit" class="submit">
          <xm-button size="large" type="primary" class="confirm-btn">确定</xm-button>
        </div>
      </div>
      <wheat-popup v-model="showGradePopup" :customStyle="customStyle" :zIndex="11111">
        <wheat-picker :showToolbar="true" :slots="gradeSlots" :visibleItemCount="5" @change="handleChangeGradeSlotValues">
          <div class="toolbar">
            <span class="toolbar-cancle" @click="handleToggleGradePopup">取消</span>
            <span class="toolbar-ok" @click="handleOkGradeSelect">完成</span>
          </div>
        </wheat-picker>
      </wheat-popup>
      <div class="cover" v-if="showSelectStu"></div>
      <xm-modal :show="showSelectStu" class="select-modal">
        <div slot="title">未关联学员</div>
        <div slot="content" class="enter">
          <p class="desc">以下为未关联的学员，可直接选择</p>
          <div style="text-align:left" v-for="(item, index) in studentList" :key="index">
            <img
              class="stu-radio-img"
              src="https://image.xiaomaiketang.com/xm/5xjd2iFit6.png"
              v-if="studentId == item.studentId"
              @click="handleChooseStudent(item.studentId)"
            />
            <img class="stu-radio-img" src="https://image.xiaomaiketang.com/xm/WGhRibD4bk.png" v-else @click="handleChooseStudent(item.studentId)" />
            <span class="name">{{ item.studentName }}</span>
          </div>
        </div>
        <div slot="buttons" class="xm-modal-buttons">
          <span class="xm-modal-button" v-on:click="handleNoSelect">不选择</span>
          <span class="xm-modal-button" v-on:click="selectStu">确定</span>
        </div>
      </xm-modal>
    </div>
  </div>
</template>
<script>
import { formatDate } from '@/core/filters';
import PayService from '@/service/PayService';
import User from '@/core/user';
import { MessageBox } from 'mint-ui';
import Platform from '@/core/platform';
import { Dialog } from 'vant';
export default {
  props: ['instId', 'addNewStudent', 'hideAddStudentPop'],
  computed: {
    // 手机号是否为登录手机号，【是】不用显示验证码，【否】需要显示验证码
    showVerifyCode: function() {
      return !User.uid() || User.uid() == '0' || this.storagePhone !== this.phone;
    },
  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      messageCode: '',
      codeStatus: false,
      storagePhone: User.phone(),
      phone: User.phone(),
      code: '',
      codeTip: '获取验证码',
      studentName: '',
      birthTime: '2020/01/01',
      gradeList: [],
      studentList: [],
      showGradePopup: false,
      gradeChooseValues: [],
      customStyle: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
      },
      gradeSlots: [],
      currentGrade: '',
      countDownDisable: true,
      codeTip: '获取验证码',
      showSelectStu: false,
      studentId: '',
      submitBtnDisable: true,
    };
  },
  created() {},
  mounted() {
    this.getGradeList();
    this.messageCode = '';
    this.codeStatus = false;
    _xm_slide.init();
    window.addEventListener('message', this.receiveMessage);
  },

  destroyed() {
    window.removeEventListener('message', this.receiveMessage);
  },
  methods: {
    selectBirthTime() {
      this.$refs.birthTime.open();
    },
    receiveMessage(e) {
      _xm_slide.remove();
      e.data.token && this.handSendCodeSucc(e.data);
    },
    // 获取年级列表
    getGradeList() {
      let id = this.instId;
      PayService.getGradeList(id).then(res => {
        let gradeList = res.data;
        gradeList.map(item => {
          item.value = item.name;
        });
        // 交换初中四年级和初中的位置
        for (let i = 0; i < gradeList.length; i++) {
          if (gradeList[i].code === '14' && gradeList[i + 1] && gradeList[i + 1].code === '15') {
            const data15 = gradeList[i + 1];
            gradeList[i + 1] = gradeList[i];
            gradeList[i] = data15;
          }
        }
        this.gradeList = gradeList;
        this.gradeSlots = [
          {
            values: this.gradeList,
            defaultIndex: 0,
          },
        ];
      });
    },
    // 显示/隐藏机构的popup
    handleToggleGradePopup() {
      this.showGradePopup = !this.showGradePopup;
    },
    // 更换消耗课程
    handleChangeGradeSlotValues(picker, values) {
      this.gradeChooseValues = values[0];
    },

    // 确认选择课程
    handleOkGradeSelect() {
      this.currentGrade = this.gradeChooseValues;
      this.gradeSlots[0].defaultIndex = this.gradeList.indexOf(this.currentInst) + 1;
      this.handleToggleGradePopup();
    },
    inputBlur() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    // 用户不选择任何未关联学员
    handleNoSelect() {
      this.showSelectStu = false;
      this.closePopup();
      this.addStu();
    },
    handleVerifyCodeBlur() {
      this.inputBlur();
    },
    handleSendCode() {
      this.countDownDisable = true;
      const self = this;
      if (this.countdown > 0 && this.countdown < 60) {
        return;
      }
      clearInterval(this.timer);
      if (!this.phone) {
        Vue.$wheatToast({
          message: '请输入手机号',
          position: 'top',
        });
        return;
      }
      if (this.phone.length !== 11) {
        Vue.$wheatToast({
          message: '请输入正确的手机号',
          position: 'top',
        });
        return;
      }
      if (this.phone.length === 11) {
        this.inputBlur();
        _xm_slide.open();
      } else {
        Vue.$wheatToast({
          message: '请输入正确的手机号',
          position: 'top',
        });
      }
    },
    // 添加学员 uid不为0
    addStu() {
      const param = {
        phone: this.phone,
        name: this.studentName,
        instId: window.getParameterByName('instId'),
        appId: User.appId(),
        notWechatPlatform: window.getParameterByName('platform') === 'ALIYUN_H5',
        userId: User.uid(),
      };
      axios
        .Customer('public/student/saveStudentAndBindUser', param, { reject: true })
        .then(res => {
          this.addNewStudent({
            instId: res.result.instId,
            studentId: res.result.studentBasicVO.studentId,
            studentName: res.result.studentBasicVO.name,
            phone: this.phone,
            selectableStatus: "AVAILABLE",
            _type: 'select'
          });
        })
        .catch(err => {
          if (err.code === 'DUPLICATE_PHONE' && !err.success) {
            return Dialog.alert({
              message: '抱歉，该手机已在机构中，无法重复创建，请直接联系机构报名',
              confirmButtonText: '我知道了',
              confirmButtonColor: '#0076ff',
            }).then(() => {});
          }
        });
    },
    selectStu() {
      const list = _.filter(this.studentList, item => {
        return this.studentId == item.studentId;
      });

      this.showSelectStu = false;
      this.addNewStudent({ ...list[0], _type: 'select' });
    },
    handSendCodeSucc(checkData) {
      const self = this;
      this.countdown = 60;
      this.countdownTick();
      this.timer = setInterval(self.countdownTick.bind(self), 1000);
      axios
        .Customer('anon/sms/cSendSmsCode', {
          sig: checkData.sig,
          sessionId: checkData.csessionid,
          token: checkData.token,
          scene: 'nc_login_h5',
          sideType: 0,
          serverType: User.uid() && User.uid() != '0' ? 'BIND_STUDENT' : 'BIND_PHONE',
          phone: this.phone,
        })
        .then(res => {
          this.isAdding = false;
          this.messageCode = res.result;
        })
        .catch(() => {
          this.timer && clearInterval(this.timer);
          this.codeTip = '获取验证码';
          this.countDownDisable = false;
          this.countdown = 60;
        });
    },
    countdownTick(res) {
      this.countdown -= 1;
      if (this.countdown < 40) {
        this.showVoiceCode = true;
      }
      if (this.countdown <= 0) {
        this.timer && clearInterval(this.timer);
        this.codeTip = '获取验证码';
        this.countDownDisable = false;
        this.countdown = 60;
      } else {
        this.codeTip = this.countdown + 's';
        this.countDownDisable = true;
      }
    },
    // 确定
    submit() {
      if (this.submiting) {
        Vue.$wheatToast({
          message: '请勿重复点击',
          position: 'top',
        });
        return;
      }
      this.submiting = true;
      setTimeout(() => {
        this.submiting = false;
      }, 2000);
      const self = this;
      if (!this.phone) {
        Vue.$wheatToast({
          message: '请输入手机号',
          position: 'top',
        });
        return;
      }
      if (this.phone.length !== 11) {
        Vue.$wheatToast({
          message: '请输入正确的手机号',
          position: 'top',
        });
        return;
      }
      if (!this.code && this.showVerifyCode) {
        Vue.$wheatToast({
          message: '请输入验证码',
          position: 'top',
        });
        return;
      }
      if (this.showVerifyCode && this.code.length !== 4) {
        Vue.$wheatToast({
          message: '验证码输入不正确',
          position: 'top',
        });
        return;
      }
      if (!this.studentName) {
        Vue.$wheatToast({
          message: '请填写学员姓名',
          position: 'top',
        });
        return;
      }
      if (this.showVerifyCode) {
        // 需要验证码
        if (User.uid() && User.uid() != '0') {
          axios
            .post('customer/public/groupToStudent/newBindAbleList', {
              phone: this.phone,
              code: this.code,
              appId: User.appId(),
              instId: window.getParameterByName('instId'),
              platform: Platform.isWeiXin() ? 'WECHAT_GZH' : 'ALIYUN_H5',
            })
            .then(res => {
              const list = [];
              const instId = window.getParameterByName('instId');

              this.codeStatus = res.success;
              _.map(res.result, item => {
                _.map(item.studentVOList, _item => {
                  if (_item.instId == instId)
                    list.push({
                      instId: instId,
                      studentId: _item.studentId,
                      studentName: _item.name,
                      phone: this.phone,
                    });
                });
              });
              if (list.length) {
                this.studentList = list;
                this.studentId = this.studentList[0].studentId;
                this.showSelectStu = true;
              } else {
                this.addStu();
              }
            });
        } else {
          // 换绑或新增帐户 uid为0时
          axios
            .Customer('public/login/changeBindPhone', {
              code: this.code,
              phone: this.phone,
              userId: User.uid(),
            })
            .then(res => {
              res.result.xmToken && User.setToken(res.result.xmToken);
              res.result.userId && User.setUid(res.result.userId);
              this.codeStatus = res.success;
              axios
                .Customer('public/user/getUserInfoById', {
                  xmToken: User.token(),
                  appId: User.appId(),
                })
                .then(res => {
                  if (res.result.id) {
                    User.setUid(res.result.id);
                    window.userConfig = res.result;
                    User.setPhone(res.result.bindPhone);
                    const query = {
                      appId: User.appId(),
                      instId: window.getParameterByName('instId'),
                      platform: Platform.isAlipay() ? 'ALIYUN_H5' : 'WECHAT_GZH',
                    };
                    axios.post('customer/public/groupToStudent/bindAbleListByUser', query, {}).then(res => {
                      const list = [];
                      const instId = window.getParameterByName('instId');
                      _.map(res.result, item => {
                        _.map(item.studentVOList, _item => {
                          if (_item.instId == instId)
                            list.push({
                              instId: instId,
                              studentId: _item.studentId,
                              studentName: _item.name,
                              phone: this.phone,
                            });
                        });
                      });
                      if (!list.length) {
                        this.addStu();
                      } else {
                        this.studentList = list;
                        this.studentId = this.studentList[0].studentId;
                        this.showSelectStu = true;
                      }
                    });
                  }
                });
            })
            .catch(() => {
              this.isAdding = false;
            });
        }
      } else {
        this.addStu();
      }
    },
    closePopup() {
      this.hideAddStudentPop();
    },
    handleChooseStudent(theStuId) {
      this.studentId = theStuId;
    },
  },
  watch: {
    phone: function(newValue, oldValue) {
      this.countDownDisable = newValue.length !== 11;
    },
    code: function(newValue, oldValue) {
      newValue = newValue + '';
      if (newValue && newValue.length == 8 && newValue.slice(0, 4) == newValue.slice(4, 8)) {
        this.code = newValue.slice(0, 4);
      }
    },
    studentName: function(newValue, oldValue) {
      if (newValue.length > 10) {
        this.studentName = newValue.slice(0, 10);
      }
    },
  },
  components: {},
};
</script>
<style lang="less" scoped>
@import url(../../core/mixins.less);

.add-student-page {
  width: 100vw;
  height: 66vh;
  .page-title {
    text-align: left;
    font-size: 0.3rem;
    color: rgba(51, 51, 51, 1);
    line-height: 0.42rem;
    padding: 0.22rem 0.32rem;
    border-radius: 0.2rem 0.2rem 0 0;
    border-bottom: 1px solid #eee;
  }
  .form {
    .item {
      background: #fff;
      // font-family: PingFangSC-Regular;
      // font-weight: 400;
      // color: rgba(51, 51, 51, 1);
      // border-bottom: 1px solid rgba(238, 238, 238, 1);
      // line-height: 44px;
      // overflow: hidden;
      // font-size: 0.3rem;
      display: flex;
      align-items: center;
      text-align: left;
      padding: 0.24rem 0.32rem;
      border-bottom: 0.5px solid #eee;
      position: relative;
      .label {
        // width: 80px;
        // float: left;
        width: 1.45rem;
        margin-right: 0.48rem;
        font-size: 0.3rem;
        color: #333333;
        line-height: 0.42rem;
        .tip {
          color: #ff4f4f;
          margin-right: 0.04rem;
        }
      }
      .inputItem {
        flex: 1;
        // margin-left: 80px;
        // display: block;
        // height: 44px;
        // position: relative;
        // .select{
        //     text-align:right;
        // }
        input {
          width: 100%;
          // display: block;
          // border: none;
          // width: 100%;
          // height: 44px;
          // line-height: 44px;
          font-size: 0.3rem;
          line-height: 0.42rem;
          &:focus,
          &:active {
            border: none;
            outline-width: 0px;
          }
          &::-webkit-input-placeholder {
            /* WebKit, Blink, Edge */
            color: #ccc;
          }
          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: #ccc;
          }
          &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: #ccc;
          }
          &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: #ccc;
          }
        }
        .verify-input {
          width: 58%;
        }
        .verify-btn {
          padding-left: 0.4rem;
          border-left: 1px solid #eee;
          color: #58b7ef;
          font-size: 0.3rem;
          line-height: 0.42rem;
        }
        .select {
          text-align: right;
          .tip {
            padding-right: 0.32rem;
            color: #cccccc;
            font-size: 0.3rem;
            line-height: 0.42rem;
          }
          .control {
            padding: 0.32rem;
            font-size: 14px;
            color: #909090;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
    .submit {
      position: fixed;
      bottom: 0.32rem;
      width: 100vw;
    }
    .confirm-btn {
      margin: 0 0.32rem;
      font-size: 0.3rem;
      height: 0.88rem;
      line-height: 0.88rem;
      background-image: linear-gradient(to right, #ff7819, #ff4200);
      border-radius: 0.1rem;
    }
  }
  .toolbar {
    height: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.4rem;
    .divide-bottom();
    .toolbar-cancle,
    .toolbar-ok {
      color: #3296fa;
    }
  }
  .cover {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.3);
    z-index: 9999;
  }
  .closeIcon {
    position: absolute;
    right: 0.32rem;
    font-size: 0.42rem;
    top: 0.1rem;
    color: #999;
  }
  .select-modal {
    .stu-radio-img {
      width: 0.36rem;
      height: 0.36rem;
      vertical-align: middle;
    }
    .desc {
      color: #999999;
      font-size: 0.26rem;
      margin: 0.3rem 0;
    }
    .name {
      color: #333333;
      font-size: 0.26rem;
      padding-left: 0.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module/mall/AddStudent.vue